<template>
  <div :class="[$style.wrap, $style.config]">
    <div :class="$style.inner">
      <slot name="header" />
      <div
        :class="[$style.layout, !computedCards?.length && $style.layoutEmpty]"
      >
        <slot />

        <div :class="$style.cardContainer">
          <slot name="beforeCards" />
          <template v-if="computedCards?.length">
            <AsideCard
              v-for="card in computedCards"
              :key="card?.sys?.id"
              :data="card"
            />
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { TypeAsideCardWithoutUnresolvableLinksResponse } from '~/types/contentful'

const props = defineProps<{
  data:
    | (TypeAsideCardWithoutUnresolvableLinksResponse | undefined)[]
    | undefined
}>()

const computedCards = computed(() => props.data?.filter?.(instanceOfAsideCard))
</script>

<style lang="scss" module>
.config {
  --wac-inner-padding-side: 20px;
  --wac-inner-padding-top: 45px;
  --wac-inner-padding-bottom: 50px;

  --wac-inner-padding: var(--wac-inner-padding-top)
    var(--wac-inner-padding-side) var(--wac-inner-padding-bottom);

  @include breakpoint-variables(
    '--wac-inner-padding-bottom',
    (
      'base': 50px,
      'sm': 50px,
      'md': 50px,
      'lg': 95px,
    )
  );
}

.wrap {
  position: relative;
  background-color: var(--wac-background-color, unset);
}

.inner {
  margin: auto;
  max-width: var(--wac-inner-max-width, 1350px);
  padding: var(--wac-inner-padding);
}

.layout {
  align-items: flex-start;
  display: grid;
  gap: 50px;

  @include media('lg') {
    grid-template-columns: 1fr 336px;
    gap: 4%;
  }
}

// If no cards
.layoutEmpty {
  @include media('lg') {
    grid-template-columns: 1fr;
    gap: 0;
  }
}

.cardContainer {
  display: grid;
  gap: 19px;
}
</style>
